import * as React from "react";

import { cn } from "@/lib/utils";
import Typography from "./typography";

const Input = React.forwardRef(({ label, className, type, ...props }, ref) => {
  return (
    <div className="w-full flex flex-col">
      {label && (
        <Typography
          variant={"p1"}
          className={`!font-lato_bold dark:text-white text-black mb-[5px]  `}
        >
          {label}
        </Typography>
      )}

      <input
        type={type}
        className={cn(
          "2xl:h-[50px] disabled:cursor-not-allowed disabled:text-gray-600 disabled:bg-gray-400/10 !appearance-none w-full outline-none  h-10  px-3 2xl:px-5 text-sm border-none 2xl:text-base dark:text-gray1 text-black dark:bg-dark4 bg-[#F8F9FA] rounded-[30px]",
          className
        )}
        ref={ref}
        {...props}
      />
    </div>
  );
});
Input.displayName = "Input";

const TextArea = React.forwardRef(
  ({ label, className, rows, type, ...props }, ref) => {
    return (
      <div>
        <Typography
          variant={"p1"}
          className={`!font-lato_bold dark:text-white text-black mb-[5px]  `}
        >
          {label}
        </Typography>

        <textarea
          type={type}
          rows={rows}
          className={cn(
            "  py-3 !min-h-[80px] 2xl:!min-h-[120px] 2xl:py-5 w-full outline-none px-3 2xl:px-5  text-sm border-none 2xl:text-base dark:text-gray1 text-black dark:bg-dark4 bg-[#F8F9FA] rounded-[30px]",
            className
          )}
          ref={ref}
          {...props}
        />
      </div>
    );
  }
);
TextArea.displayName = "Input";
export { Input, TextArea };
